import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@fontsource/noto-serif-sc/400.css'
import '@fontsource/noto-serif-sc/500.css'
import '@fontsource/noto-serif-sc/700.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import './assets/main.css'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import '@enzedonline/quill-blot-formatter2/dist/css/quill-blot-formatter2.css'
import App from './App.vue'
import router from './router'
import { lazyDirective } from './directives/lazy'

const app = createApp(App)
app.use(ElementPlus)
app.use(router)
// 全局注册图片懒加载指令：<img v-lazy="图片地址" />
app.directive('lazy', lazyDirective)
app.mount('#app')